import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'material-ui/styles';
import Checkbox from 'material-ui/Checkbox';
import Paper from 'material-ui/Paper';
import Typography from 'material-ui/Typography';
import { Tab } from '../../constants/ComponentTypes'
import FaceExcellent from '../Icons/FaceExcellent';
import FaceGood from '../Icons/FaceGood';
import FaceSilence from '../Icons/FaceSilence';
import { formatName, formatNgItemName, isEnabledUserRole } from '../../utils/utils';
import MoreVertIcon from 'material-ui-icons/MoreVert';
import DropdownMenu from '../common/DropdownMenu';
import OwnerShipLabel from "../common/OwnerShip/OwnerShipLabel";

import {
  HouseListDirectory,
  WarningAddressType,
  ErrorAddressType,
  LinkCorporationStatusType,
  DifferenceType,
  AddressType,
} from '../../constants/ComponentTypes';

const styles = () => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: '1px',
    boxSizing: 'border-box',
    borderTop: '1px solid #D8DBDF',
  },

  checkboxContainer: {
    padding: '20px',
    boxSizing: 'border-box',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  checkbox: {
    width: '20px',
    height: '20px',
  },

  addressItem: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    boxSizing: 'border-box',
    padding: '13px 0px 13px 15px',
  },

  flex: {
    flex: 1,
  },

  item: {
    marginRight: '20px',
  },

  name: {
    fontWeight: 'bold',
    lineHeight: '17px',
  },

  nameLink: {
    fontWeight: 'bold',
    lineHeight: '17px',
    '&:hover': {
      textDecoration: 'underline',
    }
  },

  address: {
    marginTop: '3px',
    lineHeight: '14px'
  },

  iconButton: {
    color: '#71737B',
    padding: 0,
    marginRight: '10px',
    width: '24px',
    minWidth: '24px',
    height: '24px',
    minHeight: '24px',
  },

  dropdown: {
    minWidth: '180px',
    margin: '12px 0 12px 12px',
  },

  btnOpened: {
    color: 'rgb(26, 101, 255)',
  },

  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '10px',
  },

  label: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #D8DBDF',
    backgroundColor: '#F4F6F9',
    color: '#181819',
    padding: '6px 12px',
    fontSize: 11,
    fontWeight: 'bold',
  },

  salesforceLabel: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #1797C0',
    backgroundColor: '#F2FCFF',
    color: '#1797C0',
    padding: '6px 12px',
    fontSize: 11,
    fontWeight: 'bold',
  },

  labelHover: {
    '&:hover': {
      textDecoration: 'underline',
    }
  },

  followCallAddressLabel: {
    color: "#195AFF",
    background: "#F2F6FF",
    border: '1px solid #195AFF',
    display: "inline-block",
    padding: '6px 12px',
    fontSize: "11px",
    fontWeight: "bold",
  },
});

class AddressItem extends React.Component {
  componentWillMount() {
    if (this.props.type === HouseListDirectory.ERROR.name) {
      if (this.props.item.detail &&
        this.props.item.detail.error_address_type &&
        this.props.item.detail.error_address_type === ErrorAddressType.NG_SENDING_ERROR.value) {
        this.setState({
          disabled: true
        })
      }
    }
  }

  /* Event Listener */
  handleClick = () => {
    if (this.props.isDemo) {
      this.props.togglePlanDialog();
    } else {
      if (this.props.onItemClicked) {
        this.props.onItemClicked(this.props.item, this.props.index, !this.props.checked);
      }
    }
  }

  handleTitleClick = () => {
    if (this.props.isDemo) {
      this.props.togglePlanDialog();
    } else {
      if (this.props.onTitleClicked) {
        this.props.onTitleClicked(this.props.item);
      }
    }
  }

  toggleDetailDialog = (e) => {
    if (this.props.isDemo) {
      this.props.togglePlanDialog();
    } else {
      if (this.props.onLabelClicked) {
        e.stopPropagation();
        this.props.onLabelClicked(this.props.item);
      }
    }
  }

  renderIcon = (status) => {
    const { type } = this.props;
    if (type === HouseListDirectory.MAIN.name) {
      switch (status) {
        case Tab.SILENT:
          return <FaceSilence width={32} height={32} />
        case Tab.REACTED:
          return <FaceGood width={32} height={32} />
        case Tab.CONVERTED:
          return <FaceExcellent width={32} height={32} />
        default:
          return <FaceSilence width={32} height={32} />
      }
    } else {
      return <FaceSilence width={32} height={32} />
    }
  };

  renderLabel = () => {
    const { classes, type, item } = this.props;

    let texts = [];
    if (type === HouseListDirectory.WARNING.name) {
      if (item.type !== undefined) {
        let warningType = Object.values(WarningAddressType).find(warningAddressType => warningAddressType.value === item.type);
        if (warningType) {
          texts.push(warningType.text);
        }
      } else if (item.duplicate_address !== null) {
        texts.push(WarningAddressType['DUPLICATE'].text);
      }
    } else if (type === HouseListDirectory.ERROR.name) {
      if (item && item.detail && item.detail.error_address_type && item.detail.error_address_type === ErrorAddressType.NG_SENDING_ERROR.value) {
        texts.push(ErrorAddressType['NG_SENDING_ERROR'].text);
      } else {
        texts.push(ErrorAddressType['VALIDATION_ERROR'].text);
      }
    } else if (type === HouseListDirectory.MAIN.name) {
      if (item.link_corporation_status === LinkCorporationStatusType.LINK_FAILURE) {
        texts.push("法人番号を確認してください");
      }

      if (item && item.address_corporation_differences && item.address_corporation_differences.length > 0) {
        item.address_corporation_differences.forEach(d => {
          switch (d.type) {
            case DifferenceType.COMPANY_NAME:
              texts.push("会社名を確認してください");
              break;
            case DifferenceType.ADDRESS:
              texts.push("住所を確認してください");
              break;
            case DifferenceType.CLOSE:
              texts.push("閉鎖が確認されました");
              break;
            default:
          }
        })
      }
    }

    if (texts.length === 1) {
      return (
        <div
          className={classNames(classes.label, this.props.onLabelClicked ? classes.labelHover : '')}
          style={{ marginRight: '10px' }}
          onClick={isEnabledUserRole(this.props.user, "house-list", "edit") ? this.toggleDetailDialog : null}>
          {texts[0]}
        </div>
      )
    } else if (texts.length > 1) {
      return (
        <div onClick={isEnabledUserRole(this.props.user, "house-list", "edit") ? this.toggleDetailDialog : null} className={classes.labelContainer}>
          <div
            className={classNames(classes.label, this.props.onLabelClicked ? classes.labelHover : '')}
            style={{ marginRight: '10px' }}
          >
            {texts[0]}
          </div>
          <Typography variant="body1">他{texts.length - 1}件の通知</Typography>
        </div>
      )
    }
  }

  renderFollowCallAddressLabel = () => {
    const { classes, item } = this.props;

    if (item.address === null || item.post_code === null || item.honorific === null) {
      return (
        <div
          className={classes.followCallAddressLabel}
          style={{ marginRight: '10px' }}
          onClick={isEnabledUserRole(this.props.user, "house-list", "edit") ? this.toggleDetailDialog : null}>
          フォローコールアドレス
        </div>
      )
    }
  }

  renderSalesforceLabel = () => {
    const { classes, type, item } = this.props;

    if (type === HouseListDirectory.MAIN.name) {
      if (item.type === AddressType.SALESFORCE.value) {
        return (
          <div
            className={classNames(classes.salesforceLabel, this.props.onLabelClicked ? classes.labelHover : '')}
            style={{ marginRight: '10px' }}
            onClick={isEnabledUserRole(this.props.user, "house-list", "edit") ? this.toggleDetailDialog : null}>
            {AddressType.SALESFORCE.text}
          </div>
        )
      }
    }
  }

  renderCheckbox = () => {
    const { classes, checked, item, index } = this.props;
    return (
      <div className={classes.checkboxContainer}>
        <Checkbox
          checked={checked}
          onClick={() => this.props.selectItem(item, index, !checked)}
          color="primary"
          className={classes.checkbox}
        />
      </div>
    );
  }

  render() {
    const { classes, checked, item, type, onItemClicked, onTitleClicked } = this.props;
    let menuItems = this.props.menuItems ? this.props.menuItems : [];
    menuItems = menuItems.filter(menuItem => {
      // フォローコールのアドレスは「レター送付」のメニューを表示しない
      return !(item && (item.address === null || item.post_code === null || item.honorific === null) && menuItem.name === "レター送付");
    }).map(menuItem => {
      return { name: menuItem.name, func: () => menuItem.func(item) };
    });

    return (
      <Paper
        className={classes.container}
        elevation={0}
        style={{
          cursor: !this.props.disabled && onItemClicked ? "pointer" : 'auto',
          pointerEvents: !this.props.disabled ? "auto" : 'none',
          background: checked ? 'rgb(26, 101, 255, 0.05)' : '#FFFFFF',
        }}
      >
        {this.renderCheckbox()}

        {(() => {
          if (type === HouseListDirectory.NG_LIST.name) {
            return (
              <div className={classes.addressItem} onClick={this.handleClick}>
                <div className={classNames(classes.flex, classes.item)}>
                  <Typography variant="body2" className={onTitleClicked ? classes.nameLink : classes.name} onClick={this.handleTitleClick}>{formatNgItemName(this.props.item)}</Typography>
                  <Typography variant="body1" className={classes.address}>法人番号:{item.corporation.corporate_number}</Typography>
                  <OwnerShipLabel name={item.ownership_user_name} />
                </div>
              </div>
            )
          } else {
            return (
              <div className={classes.addressItem} onClick={this.handleClick}>
                <div className={classes.item}>
                  {this.renderIcon(item.status)}
                </div>

                <div className={classNames(classes.flex, classes.item)}>
                  <Typography variant="body2" className={onTitleClicked ? classes.nameLink : classes.name} onClick={this.handleTitleClick}>{formatName(this.props.item)}</Typography>
                  <Typography variant="body1" className={classes.address}>{item.address}</Typography>
                  <OwnerShipLabel name={item.ownership_user_name} />
                </div>

                {this.renderFollowCallAddressLabel()}
                {this.renderSalesforceLabel()}
                {this.renderLabel()}
              </div>
            )
          }
        })()}

        {(() => {
          if (menuItems && menuItems.length > 0) {
            return (
              <DropdownMenu
                menuItems={menuItems}
                classes={{
                  btn: classes.iconButton,
                  btnOpened: classes.btnOpened,
                  dropdown: classes.dropdown,
                }}
                popperPlacement="bottom-end"
              >
                <MoreVertIcon />
              </DropdownMenu>
            )
          }
        })()}
      </Paper>
    );
  }
}

AddressItem.propTypes = {
  classes: PropTypes.object.isRequired,
  checked: PropTypes.bool,
  item: PropTypes.object.isRequired,
  onItemClicked: PropTypes.func,
  onLabelClicked: PropTypes.func,
  onTitleClicked: PropTypes.func,
  selectItem: PropTypes.func,
  type: PropTypes.string,
  menuItems: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  isDemo: PropTypes.bool,
  togglePlanDialog: PropTypes.func,
  user: PropTypes.object,
};

AddressItem.defaultProps = {
  type: HouseListDirectory.MAIN.name,
}

export default withStyles(styles)(AddressItem);



// WEBPACK FOOTER //
// ./src/components/AddressBook/AddressItem.jsx